// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Mayachain Unchained API
 * Provides access to mayachain chain data.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Tx } from './Tx';
import {
    TxFromJSON,
    TxFromJSONTyped,
    TxToJSON,
} from './Tx';

/**
 * Contains info about transaction history for an address or xpub
 * @export
 * @interface TxHistory
 */
export interface TxHistory {
    /**
     * Base64 encoded string to fetch next page or undefined if no more data avaiable
     * @type {string}
     * @memberof TxHistory
     */
    cursor: string;
    /**
     * 
     * @type {string}
     * @memberof TxHistory
     */
    pubkey: string;
    /**
     * 
     * @type {Array<Tx>}
     * @memberof TxHistory
     */
    txs: Array<Tx>;
}

/**
 * Check if a given object implements the TxHistory interface.
 */
export function instanceOfTxHistory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cursor" in value;
    isInstance = isInstance && "pubkey" in value;
    isInstance = isInstance && "txs" in value;

    return isInstance;
}

export function TxHistoryFromJSON(json: any): TxHistory {
    return TxHistoryFromJSONTyped(json, false);
}

export function TxHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TxHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cursor': json['cursor'],
        'pubkey': json['pubkey'],
        'txs': ((json['txs'] as Array<any>).map(TxFromJSON)),
    };
}

export function TxHistoryToJSON(value?: TxHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cursor': value.cursor,
        'pubkey': value.pubkey,
        'txs': ((value.txs as Array<any>).map(TxToJSON)),
    };
}

